// Constants
import {
    INITIALIZE_REGISTERED_EVENTS,
    REGISTERED_EVENTS_LOADING,
    MARK_EVENT,
} from "@/store/actions/registeredEventsActions";
const initialState = { loading: true, data: {} };

const registeredEventsReducer = (state = initialState, action) => {
    if (action.type === REGISTERED_EVENTS_LOADING) {
        return {
            ...state,
            loading: true,
        };
    } else if (action.type === INITIALIZE_REGISTERED_EVENTS) {
        return {
            ...state,
            data: action.payload,
            loading: false,
        };
    } else if (action.type === MARK_EVENT) {
        return {
            ...state,
            data: {
                ...state.data,
                [action.payload.cmsId]: {
                    ...action.payload,
                    registered: true,
                },
            },
        };
    } else {
        return state;
    }
};

export default registeredEventsReducer;
